import React from 'react'

const TimesPlayedRow = ({filter, conditionsList, updateNumberCondition, updateValue}) => {
  return (
    <span>
      <i className='fa fa-hourglass-start' aria-hidden='true' title='longer execution time (reading archived data)'></i>&nbsp;
      <select
        name='filter-condition'
        value={filter.conditionChild}
        onChange={e=> updateNumberCondition(e.target.value)}>
        { conditionsList.map((o, i) => <option key={i} value={o}>{o}</option>) }&nbsp;
      </select>
      {!['is empty', 'is not empty'].includes(filter.conditionChild) &&
        <input className='filter-form-input' placeholder='Select an option' type='number' value= {filter.value}
               onChange={(e) => {updateValue(e.target.value)}}/>}
    </span>
  )
}

export default TimesPlayedRow
